module.exports = __webpack_public_path__ + "static/media/ic-medicine-heart-hear.3c3a7356.svg";